export default "__VITE_ASSET__19164b12__"